import type { MediaType } from '@/types/movie';

export interface CategoryMeta {
  type: MediaType;
  title: string;
  description: string;
  genres: string[];
}

export const categoryMeta: Record<MediaType, CategoryMeta> = {
  movie: {
    type: 'movie',
    title: '电影',
    description: '最新上映与高分电影推荐，涵盖动作、爱情、科幻、悬疑、动画等丰富题材。',
    genres: ['动作', '爱情', '剧情', '科幻', '悬疑', '喜剧', '犯罪', '冒险', '奇幻', '动画', '历史', '武侠'],
  },
  tv: {
    type: 'tv',
    title: '电视剧',
    description: '热播剧集与口碑好剧，古装权谋、都市情感、悬疑推理、医疗年代一应俱全。',
    genres: ['剧情', '悬疑', '都市', '历史', '战争', '爱情', '青春', '犯罪', '古装', '年代', '医疗', '科幻'],
  },
  variety: {
    title: '综艺',
    type: 'variety',
    description: '真人秀、音乐、竞技类综艺精选，轻松下饭与舞台竞演都在这儿。',
    genres: ['真人秀', '竞技', '音乐', '喜剧', '生活', '美食', '悬疑'],
  },
};

export function getCategoryMeta(type: string): CategoryMeta | undefined {
  return categoryMeta[type as MediaType];
}